import { DataById } from '../map/types';
import type * as schema from '@api/schema';
import { ExtendedKeplerGlState } from './kepler-reducer';

export type VisStateExtension = {
    userKeplerStyleIdByLayerId: DataById<
        schema.definitions['entities_replancity_KeplerLayerProperties']
    >;
};

export const enum CustomKeplerActions {
    SAVE_KEPLER_STYLE_ID_BY_LAYER_ID = 'SAVE_KEPLER_STYLE_ID_BY_LAYER_ID',
    DELETE_KEPLER_STYLE_ID_BY_LAYER_ID = 'DELETE_KEPLER_STYLE_ID_BY_LAYER_ID',
}

export const saveKeplerStyleIdByLayerId = (
    userKeplerStyleIdByLayerId: VisStateExtension['userKeplerStyleIdByLayerId']
) => ({
    type: CustomKeplerActions.SAVE_KEPLER_STYLE_ID_BY_LAYER_ID,
    payload: userKeplerStyleIdByLayerId,
});

export const deleteKeplerStyleIdByLayerId = (layerId: string) => ({
    type: CustomKeplerActions.DELETE_KEPLER_STYLE_ID_BY_LAYER_ID,
    payload: layerId,
});

export const visStatePlugin = {
    [CustomKeplerActions.SAVE_KEPLER_STYLE_ID_BY_LAYER_ID]: (
        state: ExtendedKeplerGlState,
        action
    ) => {
        const userKeplerStyleIdByLayerId = action.payload;
        return {
            ...state,
            visState: {
                ...state.visState,
                userKeplerStyleIdByLayerId: {
                    ...state.visState.userKeplerStyleIdByLayerId,
                    ...userKeplerStyleIdByLayerId,
                },
            },
        };
    },
    [CustomKeplerActions.DELETE_KEPLER_STYLE_ID_BY_LAYER_ID]: (
        state: ExtendedKeplerGlState,
        action
    ) => {
        const layerId = action.payload;
        const {
            userKeplerStyleIdByLayerId: { [layerId]: toDelete, ...restUserKeplerStyleIdByLayerId },
        } = state.visState;
        return {
            ...state,
            visState: {
                ...state.visState,
                userKeplerStyleIdByLayerId: restUserKeplerStyleIdByLayerId,
            },
        };
    },
};
